var menuListStatic = {};

function menuList() {
	//this.scroll = new Scroller("#panos","#ui");
	menuListStatic = this;
}

menuList.prototype = {
	lastItem:null,
	items:[],
	
	back: function() {
		var chs = player.currentHistoryState;
		
		$(chs.current).hide();
		
		$(chs.parent).show();
		
		/*
		$("#panosback a").last().parent().remove();
		
		$("#panosback .breadcrumb").last().children(".bcend").css("display", "none");
		*/
		
		//$(chs.current).css("opacity","0");		
		//$(chs.parent).css("opacity","1");
		
		/*
		$(chs.current).css("transform","translate3d(" + player._width + "px,0px,0px)");
		$(chs.current).css("-webkit-transform","translate3d(" + player._width + "px,0px,0px)");
		$(chs.current).css("-moz-transform","translate3d(" + player._width + "px,0px,0px)");
		
		$(chs.parent).css("transform","translate3d(0px,0px,0px)");
		$(chs.parent).css("-webkit-transform","translate3d(0px,0px,0px)");
		$(chs.parent).css("-moz-transform","translate3d(0px,0px,0px)");
		*/
	},
	
	multiBack: function(event) {
		if (player.list.lastItem != null) {
			$("#" + player.list.lastItem.id).hide();
			player.list.lastItem = player.list.lastItem.parent;
			if (player.list.lastItem != null) $("#" + player.list.lastItem.id).show();
			else history.back();
		} else {
			history.back();
		}
		
		event.preventDefault();
		/*
		var cp = $(this).attr("data-count");
		var max = $("#panosback a").length;
		
		if (cp == undefined) cp = 0;
		
		if (max == 1) history.back();
		
		for(var i = 0; i < max - cp; i ++) {
			history.back();
		}
		*/
	},
	
	openMenu: function(item) {
		//console.log("open submenu " + pdiv);
				
		if (item == null) {
			if (player.list.lastItem != null) $("#" + player.list.lastItem.id).hide();
			$("#rootmenu").show();
		
		} else if (item.id != "") {
			if (player.list.lastItem != null) {
				$("#" + player.list.lastItem.id).hide();
			} else {
				$("#rootmenu").hide();
			}
			$("#" + item.id).show();
		}
		
		player.list.lastItem = item;
	},
	
	showSubmenu: function(event) {		
		var sid = "#" + $(this).attr("data-sub");
		var parent = $(this).attr("data-parent");

		var stateObj = { "current": sid, "parent": parent };

		if (menuListStatic.scroll.isScrolling()) {
			return;
		}
		
		player.addToHistory(stateObj, $(this).attr("data-title"), sid);
		
		/*
		var nm = $("<div class='breadcrumb'><img src='assets/bc_div.png' height='20'><a href='javascript:void(null);' data-count='" + $("#panosback a").length + "'>" + $(this).attr("data-title") + "</a><img src='assets/bc_div_end.png' height='20' style='float:right;display:none;' class='bcend'></div>");
		
		$("#panosback .breadcrumb").last().children(".bcend").css("display", "block");
		
		$("#panosback").append(nm);
		
		nm.on("click", "a", player.list.multiBack);
		*/
		//$(parent).css("opacity","0");
		$(parent).hide();
		
		$(sid).show();
		//$(sid).css("opacity","1");
		
		/*
		$(parent).css("transform","translate3d(-" + player._width + "px,0px,0x)");
		$(parent).css("-webkit-transform","translate3d(-" + player._width + "px,0px,0px)");
		$(parent).css("-moz-transform","translate3d(-" + player._width + "px,0px,0px)");
		
		$(sid).show();
		$(sid).css("transform","translate3d(0px,0px,0px)");
		$(sid).css("-webkit-transform","translate3d(0px,0px,0px)");
		$(sid).css("-moz-transform","translate3d(0px,0px,0px)");
		*/
		this.scroll.calculateBounds();
		event.preventDefault();
	},

	loadRec: function(data, parent, apnd, parentData, parentItem) {
	
		if (parentData != null) {
			elem = $("<div class='folder' style='border-bottom:2px solid #ffffff;'><a href='javascript:void(null);' data-title='" + parentData.title + "' style='color: #919191;'><div class='lglyph'>&laquo;</div>" + parentData.title  + "</a></div>");
			$(apnd).append(elem);
			
			elem.children("a").on("touchend", this.multiBack);
		}
		
		for(var i = 0; i < data.length; i ++) {
		
			if (data[i].pano_id == player.ident) {
				//navbar.setMenu(data,parentData, "sub_" + parent);
				navbar.setMenu(parentItem, data[i]);
			}
			
			if (data[i].childs != undefined) {
				elem = $("<div class='folder'><a href='javascript:void(null);' data-parent='" + apnd + "' data-title='" + data[i].title + "' data-sub='sub_" + parent + "_" + i + "'>" + data[i].title  + "</a><div class='glyph'>&raquo;</div></div>");
				var ts3d = "translate3d(" + player._width + "px, 0px, 0px)";
//				sub = $("<div id='sub_" + parent + "_" + i + "' style='transform:" + ts3d + ";-webkit-transform:" + ts3d + ";display:none;' class='menu'></div>");
				sub = $("<div id='sub_" + parent + "_" + i + "' style='display:none;' class='menu'></div>");
				$(apnd).append(elem);
				$("#panos").append(sub);
				
				elem.children("a").on("touchend", this.showSubmenu);				
				
				var item = {"id" : "sub_" + parent + "_" + i, "parent" : parentItem, "title" : data[i].title};
				this.items.push(item);
				
				this.loadRec(data[i].childs, parent + "_" + i, "#sub_" + parent + "_" + i, data[i], item);
			} else {
				if (data[i].pano_id.substr(0,5) == "link=") 
					elem = $("<div class='folder'><a href='javascript:void(null);' ontouchend='menuListStatic.openUrl(\"http://" + data[i].pano_id.substr(5) + "\", true, 0);'>" + data[i].title  + "</a></div><div id='sub_" + parent + "_" + i + "' style='margin-left:50px;'></div>");
				else {
					if (data[i].look_at) look = data[i].look_at;
					else look = 0;
					elem = $("<div class='folder'><a href='javascript:void(null);' ontouchend='menuListStatic.openUrl(\"" + data[i].pano_id + "\", false, " + look + ");'>" + data[i].title  + "</a></div><div id='sub_" + parent + "_" + i + "' style='margin-left:50px;'></div>");
				}
				
//				elem = $("<div class='panolink'><a href='index.php?id=" + data[i].item[1] + "'><img src='" + data[i].thumb + "' width='200' height='100'><div class='bg'><span>" + data[i].item[0].title + "</span></div></a></div>");
				$(apnd).append(elem);
			}
		}
		this.scroll.calculateBounds();
	},
	
	openUrl: function(url, blank, dir) {

		if (menuListStatic.scroll.isScrolling()) {
			return;
		}
	
		if (!blank) 
			player.go(url, dir);
			//document.location = url;
		else {
		//	window.open(url,'_blank');
		}
	},
	
	loadPanoList: function(data) {
		var currentpano;
		var current = {id:"-1", title:"Lista panoram"};
		current.panos = [];
		
		this.scroll = new Scroller("#panos","#ui");
		
		data = player.current.menu;
		
		//console.log(data);
		
		navbar.setTitle(player.current.place_name);
		
		if (!player.imagesLoaded) {
			
			var root = $("<div class='menu' id='rootmenu'></div>");
			$("#panos").append(root);
			
			var parentItem = {"id" : "rootmenu", "parent" : null, "title" : ""};
			this.items.push(parentItem);
			
			this.loadRec(data, "", "#rootmenu", null, parentItem);
			/*
			for(var i = 0; i < data.length; i ++) {
				elem = $("<div class='folder'><a href='javascript:void(null);' onclick='player.list.loadFolder(" + player.folders.length + ");'>" + data[i].item[0].title  + "</a></div><div id='folder_" + player.folders.length + "'></div>");
				
				$("#panos").append(elem);
			}	
			*/
			player.imagesLoaded = true;
		}
	}
}